// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export var ICON_FONT_FAMILY = 'spacesword';
export var CODE_FALLBACK_FONT_STACK = 'Consolas, Monaco, Courier New, monospace';
export var CODE_FONT_FAMILY = 'Source Code Pro';
export var CODE_FONT_WEIGHT = '500';
export var WEB_FONT_REGULAR = 'Avenir Next W02';
export var WEB_FONT_BOLD = 'Avenir Next W02';
export var WEB_FONT_MEDIUM = 'Avenir Next W02';
export var WEB_FONT_DEMI_BOLD = 'Avenir Next W02';
export var WEB_FONT_ITALIC = 'Avenir Next W02';
export var WEB_FONT_REGULAR_WEIGHT = '400';
export var WEB_FONT_BOLD_WEIGHT = '700';
export var WEB_FONT_MEDIUM_WEIGHT = '500';
export var WEB_FONT_DEMI_BOLD_WEIGHT = '600';
export var WEB_FONT_ITALIC_WEIGHT = '400';
export var FALLBACK_FONT_STACK = 'Helvetica, Arial, sans-serif';
export var HEADING_FONT_SMOOTHING = 'antialiased';
export var PAGE_TITLE_FONT_WEIGHT = 'demibold';
export var HEADING_WEIGHT1 = 'bold';
export var HEADING_WEIGHT2 = 'regular';
export var HEADING_WEIGHT3 = 'medium';
export var HEADING_WEIGHT4 = 'demibold';
export var HEADING_WEIGHT5 = 'demibold';
export var HEADING_WEIGHT6 = 'demibold';
export var HEADING_WEIGHT7 = 'demibold';
export var HEADING_CASE6 = 'uppercase';
export var INPUT_VERTICAL_ALIGNMENT = 'middle';
export var TABLE_HEADER_FONT_WEIGHT = 'medium';
export var TABLE_HEADER_VERTICAL_ALIGNMENT = 'middle';
export var TABLE_CELL_VERTICAL_ALIGNMENT = 'middle';
export var TOOLTIP_SHADOW = '0 3px 8px rgba(0, 0, 0, .1)';
export var HOVERLAY_OPACITY = '0.85';